import React from "react"

export const renderDisplayCard = ({ key, title, iconMarkup, summary }) => {
  return (
    <div className="display-card" key={key}>
      <div className="display-card__title">
        <h2 className="heading-secondary">{title}</h2>
      </div>
      <div className="display-card__icon">{iconMarkup}</div>
      <div className="display-card__summary">
        <p className="paragraph">{summary}</p>
      </div>
    </div>
  )
}
